export const isArrayContentEqual = (a, b) =>
    a.length === b.length &&
    [...new Set([...a, ...b])].every(
        v => a.filter(e => e === v).length === b.filter(e => e === v).length
    );

export const normalizeValue = (value) => {
    if (value === '' || value === null || value === undefined) {
        return '';
    }
    return value;
};

// Sort adblocks by status: not started first,dupe approved last
// TODO: dupe remaining in the middle, missing fields
export const sortAdblocksByStatus = (adblocks, currentType) => {
  return [...adblocks].sort((a, b) => {
    const getStatusPriority = (item) => {
      // Check if approved 
      const isApproved =
        (currentType === "offer" && item?.offers_approved) ||
        (currentType === "product" && item?.products_approved);

      if (isApproved) return 3;

      // Check if rejected or dne
      const isRejected = item?.rejected;
      const isDNE = item?.do_not_enter_f;

      if (isRejected || isDNE) return 2;

      // Not started 
      return 1;
    };

    return getStatusPriority(a) - getStatusPriority(b);
  });
};

// 5 -> 5.00
export const formatDollarValue = (inputValue) => {
  if (inputValue === null || inputValue === undefined || inputValue === "") {
    return "";
  }

  const numericValue = Number.parseFloat(`${inputValue}`.replace(/[^0-9.]/g, ""));

  if (Number.isNaN(numericValue)) {
    return inputValue;
  }

  return numericValue.toFixed(2);
};